import { render, staticRenderFns } from "./ContadorBureau.vue?vue&type=template&id=c55fe658&scoped=true"
import script from "./ContadorBureau.vue?vue&type=script&lang=js"
export * from "./ContadorBureau.vue?vue&type=script&lang=js"
import style0 from "./ContadorBureau.vue?vue&type=style&index=0&id=c55fe658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55fe658",
  null
  
)

export default component.exports